import React from "react";
import { Tooltip } from "@mui/material";
import { CloudUpload } from "lucide-react";

/** Marks a hook whose video is already uploaded to the ad account on Meta, ready for its ad set. */
const VideoOnMetaChip = () => {
  return (
    <Tooltip
      arrow
      title="Uploaded to the ad account's media library on Meta when this hook was approved. The ad set uses it once every hook is approved."
    >
      <span className="inline-flex items-center gap-1 rounded-full border border-sky-200 bg-sky-50 px-2 py-0.5 text-xs font-medium text-sky-700">
        <CloudUpload className="h-3 w-3" />
        Video on Meta
      </span>
    </Tooltip>
  );
};

export default VideoOnMetaChip;
